'use strict';
import React, { PureComponent } from 'react';
import CabeceraRenglonModelo from './CabeceraRenglonModelo';
import RegistroRenglonModelo from './RegistroRenglonModelo';


class SeccionRenglonesModelo extends PureComponent {
    constructor(props) {
        super(props);

        this.exportarExcel = this.exportarExcel.bind(this)
        this.funcionLlamadaModalABMModelos = this.funcionLlamadaModalABMModelos.bind(this);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    funcionLlamadaModalABMModelos() {
        this.props.datosEdicionRenglon({});
        this.props.mostrarOcultarModalABMModelos("modalAltaEdicionRenglonContable", true);
    }

    async exportarExcel() {
        await this.props.armarDatosExportacionExcel(this.props.datosRenglones, this.props.criteriosRenglon);
        this.props.descargarExcel(this.props.datosRenglonesExcel);
    }

    render() {
        const {
            criteriosRenglon,
            datosRenglones,
            datosRenglonesExcel,
            errorValidacion,
            esEdicion,
            inputCodigoModelo,
            mensajeValidacionRenglonesIguales,
            permisoAlta,
            permisoModificacion,
            registroDesplegado
        } = this.props;
        
        //ACTIONS
        const {
            agregarEliminarRenglonContable,
            cargarValoresModalCopiarRenglonContable,
            datosEdicionRenglon,
            mostrarOcultarDatosAdicionalesRenglon,
            mostrarOcultarModalABMModelos
        } = this.props;

        const registrosArray = [];
        const arrayMockRegistros = [
            {Id: 1, tipoOperacion: "DEBE", nroRenglon: 1, descripcion: "Prueba renglón 1", cuentaContable: "10.111.05.01 Clearing", tipoMovimiento: "Consumo", campo: "Importe total", moneda: "Peso", estaDesplegado: true},
            {Id: 2, tipoOperacion: "HABER", nroRenglon: 2, descripcion: "Prueba renglón 2", cuentaContable: "10.111.05.02 Deuda", tipoMovimiento: "Consumo", campo: "Importe total", moneda: "Peso", estaDesplegado: false},
            {Id: 3, tipoOperacion: "DEBE", nroRenglon: 3, descripcion: "Prueba renglón 3", cuentaContable: "10.111.05.01 Clearing", tipoMovimiento: "Consumo", campo: "Importe Impuesto", moneda: "Peso", estaDesplegado: false},
            {Id: 4, tipoOperacion: "HABER", nroRenglon: 4, descripcion: "Prueba renglón 4", cuentaContable: "10.111.05.02 Deuda", tipoMovimiento: "Consumo", campo: "Importe Impuesto", moneda: "Peso", estaDesplegado: false},
        ];

        let registro = {
            id: null,
            tipoOperacion: null,
            nroRenglon: null,
            descripcion: null,
            cuentaContable: null,
            tipoMovimiento: null,
            campo: null,
            moneda: null
        }

        let claseUltimoRegistro = "";
        let criterios = [];
        let cantidadRenglones = datosRenglones ? datosRenglones.length : 0;

        //Filtro los renglones que no han sido eliminados
        let renglonesNoEliminados = this.props.datosRenglones && this.props.datosRenglones.length > 0 ? this.props.datosRenglones.filter(renglon => {return !renglon.DeleteInstance}) : [];
        cantidadRenglones = renglonesNoEliminados.length;

        renglonesNoEliminados.map((reg, index) => {
            let esPar = (index + 1) % 2 == 0;

            //agrego un margin-bottom al último registro para que no esté tan pegado del fondo
            claseUltimoRegistro = renglonesNoEliminados.length == index + 1 ? " seccionRenglonesModelo__renglonModelo__contenedorDatosAdicionales--ultimoRegistro" : "";

            registro = {
                id: reg.ModeloContableDetalleId,
                tipoOperacion: reg.TipoOperacion == 0 ? "AMBOS" : reg.TipoOperacion == 1 ? "DEBE" : "HABER",
                nroRenglon: reg.NroRenglon,
                descripcion: reg.DescripcionRenglon,
                cuentaContable: reg.CuentaContableCodigo + " " + reg.CuentaContableDescripcion,
                tipoMovimiento: reg.TipoMovDescripcion,
                campo: reg.CampoImporteDescripcion,
                moneda: reg.MonedaSalidaDescripcion,
                estaDesplegado: registroDesplegado == reg.NroRenglon,
                tipoRenglon: reg.TipoRenglon == 1 ? "Automático" : reg.TipoRenglon == 2 ? "Manual" : "Balanceo Automático",
                tipoApertura: reg.TipoApertura == 1 ? "Sin Apertura" : reg.TipoApertura == 2 ? "Socio" : "Movimiento",
                centroCosto: reg.CentroCostoId == 0 ? "Ninguno" : reg.CentroCostoDescripcion ? reg.CentroCostoDescripcion  : "Asociado a la sucursal",
                signo: reg.SignoCampo ? reg.SignoCampo : "Ambos"
            }

            if (criteriosRenglon && reg.TipoRenglon == 1 ) {
            criterios = criteriosRenglon.filter(criterio => {if(criterio.ModeloDetalleId) {return criterio.ModeloDetalleId == registro.id} else {return criterio.referenciaRenglonCriterio == reg.referenciaRenglonCriterio}});
            }
            registrosArray.push(<RegistroRenglonModelo
                                    agregarEliminarRenglonContable={agregarEliminarRenglonContable}
                                    cargarValoresModalCopiarRenglonContable={cargarValoresModalCopiarRenglonContable}
                                    datosEdicionRenglon={datosEdicionRenglon}
                                    mostrarOcultarDatosAdicionalesRenglon={mostrarOcultarDatosAdicionalesRenglon}
                                    mostrarOcultarModalABMModelos={mostrarOcultarModalABMModelos}
                                    mostrarOcultarModalAltaEdicionRenglonContable={mostrarOcultarModalABMModelos}
                                    mostrarOcultarModalCopiarRenglonContable={mostrarOcultarModalABMModelos}

                                    claseUltimoRegistro={claseUltimoRegistro}
                                    criterios={criterios}
                                    esPar={esPar}
                                    key={registro.id ? registro.id : reg.referenciaRenglonCriterio ? "Copia_" + reg.referenciaRenglonCriterio.toString() : reg.DescripcionRenglon.replace(" ","")}
                                    mostrarSignoAmbos={reg.TipoRenglon == 3}
                                    permisoModificacion={permisoModificacion}
                                    registro={registro}
                                    renglon={reg}
                                />);
        });

        const botonHabilitado = (!esEdicion && permisoAlta) || (esEdicion && permisoModificacion);

        const mostrarTooltip = !(inputCodigoModelo && datosRenglones.length > 0);
        let tooltipMensaje = "";
        // Verificar si falta el código modelo y los renglones
        if (!inputCodigoModelo && datosRenglones.length === 0) {
            tooltipMensaje = "Debe completar el código modelo y agregar renglones para exportar";
        }

        // Verificar si falta solo el código modelo
        if (!inputCodigoModelo && datosRenglones.length > 0) {
            tooltipMensaje = "Debe completar el código modelo para poder exportar";
        }

        // Verificar si faltan solo los renglones
        if (inputCodigoModelo && datosRenglones.length === 0) {
            tooltipMensaje = "Debe agregar renglones para poder exportar";
        }
        return (
            <div className="seccionRenglonesModelo">
                <div className="TituloPrincipal">
                    Renglones del Modelo
                </div>

                <div className="lineaDivisoria"></div>

                <div className="seccionRenglonesModelo__contenedorInfoGeneralBotones">
                    <div className="seccionRenglonesModelo__contenedorInfoGeneralBotones__cantidadRenglones">
                        {`Cantidad de renglones: ${cantidadRenglones}`}
                    </div>

                    <div className="seccionRenglonesModelo__contenedorInfoGeneralBotones__botonAgregar">
                        <button className={"seccionRenglonesModelo__botonAgregar" + (botonHabilitado ? "" : " ABMModelosModalContainer__botonAceptar--deshabilitado")} onClick={ botonHabilitado ? this.funcionLlamadaModalABMModelos : null}>
                            + Agregar
                        </button>
                    </div>

                    <div className="seccionRenglonesModelo__contenedorInfoGeneralBotones__botonReemplazar">
                        <button className={"seccionRenglonesModelo__botonReemplazar" + (permisoModificacion ? "" : " ABMModelosModalContainer__botonAceptar--deshabilitado")} onClick={() => permisoModificacion ? mostrarOcultarModalABMModelos("modalReemplazarCuentasContables", true) : null}>
                            Reemplazar cuentas
                        </button>
                    </div>

                    <div
                        className={mostrarTooltip ?  "seccionRenglonesModelo__contenedorInfoGeneralBotones__botonExcel_deshabilitado" : "seccionRenglonesModelo__contenedorInfoGeneralBotones__botonExcel"}
                        onClick={inputCodigoModelo && datosRenglones.length > 0 ? this.exportarExcel : null}
                        data-toggle="tooltip"
                        data-title={mostrarTooltip ? tooltipMensaje : null}
                        data-placement="top"
                        data-original-title={mostrarTooltip ? tooltipMensaje : null}
                    >
                    </div>

                </div>

                <CabeceraRenglonModelo />

                {registrosArray}

                {errorValidacion.seccionRenglones ? 
                    <div>
                        <label className="error">{errorValidacion.seccionRenglones}</label>
                    </div>
                :
                    null
                }

                {mensajeValidacionRenglonesIguales != "" ?
                    <div>
                        <label className="genericLabel warningMessage">{mensajeValidacionRenglonesIguales}</label>
                    </div>
                :
                    null
                }
            </div>
        );
    }
}

export default SeccionRenglonesModelo;